export const INVALID_ORDER = 'INVALID_ORDER';
export const ORDER_OUTSIDE_TIMEFRAME = 'ORDER_OUTSIDE_TIMEFRAME';

export default function getOrderError(message?: string) {
  if (!message) return null;

  if (message === INVALID_ORDER) {
    return 'Unfortunately your order is not eligible for return.';
  }
  if (message === ORDER_OUTSIDE_TIMEFRAME) {
    return "Sorry, your order is not eligible for return as it's now outside our return policy timeframe.";
  }
  if (message.includes('have already received a return request')) {
    return 'We have already received a return request for your order and it is currently processing.';
  }
  if (message.includes('purchase information could not be found')) {
    return "Sorry, we couldn't find your order or it's not available for a return yet. Please allow for your order status to be updated to delivered (which may take up to 24 hours), before applying for a return.";
  }

  return "We're sorry, but we're having some technical difficulties. Please try again later";
}
